import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { IconButton, Box, Typography } from "@mui/material";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5, 2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.secondary[300]}`
  }
}));

const DualListItem = ({
  details: { name, highlighted, subtitles, hideArrow },
  icon,
  onAction,
  disabled
}) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      bgcolor={highlighted ? "rgba(76, 175, 80, 0.08)" : "unset"}
      data-qa="dual-list-item"
    >
      <Box display="flex" flexDirection="column" overflow="hidden">
        <Typography
          sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
          noWrap
        >
          {name}
        </Typography>
        {subtitles &&
          subtitles.map(
            (subtitle, index) =>
              subtitle && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
                  noWrap
                  key={"subtitle-" + index}
                >
                  {subtitle}
                </Typography>
              )
          )}
      </Box>

      {onAction && !hideArrow && (
        <IconButton
          data-qa={name}
          onClick={onAction}
          disabled={disabled}
          size="large"
        >
          {icon}
        </IconButton>
      )}
    </Box>
  );
};

export default DualListItem;

DualListItem.propTypes = {
  details: PropTypes.shape({
    name: PropTypes.string,
    subtitles: PropTypes.arrayOf(PropTypes.string),
    highlighted: PropTypes.bool
  }),
  disabled: PropTypes.bool
};
